var map = {
	"./001.png": "rsAd",
	"./002.png": "vYR7",
	"./003.png": "kpEK",
	"./004.png": "bUcI",
	"./005.png": "WKc8",
	"./006.png": "W5Sl",
	"./007.png": "rQdi",
	"./008.png": "DUvH",
	"./009.png": "mL4c",
	"./010.png": "H+Pw",
	"./011.png": "PtUZ",
	"./012.png": "0pgd",
	"./013.png": "OWQz",
	"./014.png": "7xFG",
	"./015.png": "DLkX",
	"./050.png": "ofWP",
	"./051.png": "2KI5",
	"./052.png": "XPY2",
	"./053.png": "t6JM",
	"./054.png": "L0Wv",
	"./055.png": "H65c",
	"./056.png": "VIsZ",
	"./057.png": "T5xb",
	"./059.png": "kBIP",
	"./060.png": "NHI4",
	"./061.png": "gm7I",
	"./062.png": "OiyX",
	"./071.png": "Uuba",
	"./072.png": "RNBJ",
	"./073.png": "BxSE",
	"./081.png": "vBGV",
	"./082.png": "FrLN",
	"./083.png": "RK1V",
	"./084.png": "Ulaa",
	"./085.png": "Jv6s",
	"./086.png": "ZuM1",
	"./087.png": "BJmj",
	"./088.png": "ezvP",
	"./089.png": "BDLo",
	"./090.png": "bl3c",
	"./091.png": "wbAd",
	"./092.png": "sbDn",
	"./093.png": "Unp/",
	"./094.png": "jrsq",
	"./095.png": "/+Km",
	"./099.png": "klyB",
	"./box1.png": "l0Cz",
	"./box2.png": "TqQg",
	"./box3.png": "B+MV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mcWR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy ^\.\/.*\.png$
// module id = mcWR
// module chunks = 0